<template>
  <div class="help-wrapper" :class="{'mobile': isMobile}">
    <!-- <submiterrorform :mobile='isMobile' /> -->
    <faqinfo :mobile='isMobile' />
  </div>
</template>

<script>
// import submiterrorform from "../components/help/SubmitError";
import faqinfo from "../components/help/FAQ";
import isMobileMixin from "../mixins/isMobileMixin";

export default {
  props: {
    orientation: Boolean,
  },
  components: {
    // submiterrorform,
    faqinfo,
  },
  mixins: [isMobileMixin],
};
</script>

<style lang="scss" scoped>
.help-wrapper {
	overflow: auto;
  width: calc(100% - 65px);
  height: 100%;
  &.mobile {
    &.landscape {
      left: var(--nav-height);
      bottom: 0;
      height: unset;
    }
    &.portrait {
      width: 100%;
			height: calc(100% - 130px);
    }
  }
}
</style>